export enum SystemLogTypes {
  CAMERA_LOG = 'CameraLog',
  CAMERA_SERVER_LOG = 'CameraServerLog',
  DOOR_LOG = 'DoorLog',
  DYNAMIC_COUNTER_LOG = 'DynamicCounterLog',
  ENGINE_LOG = 'EngineLog',
  OFFLINE_SERVER_LOG = 'OfflineServerLog',
  PASSAGE_LOG = 'PassageLog',
  TERMINAL_LOG = 'TerminalLog',
  BARRIER_LOG = 'BarrierLog',
  IKSORIS_PARKING_TICKET_CASH_MACHINE_LOG = 'IksorisParkingTicketCashMachineLog',
  IKSORIS_PARKING_TICKET_CASHLESS_MACHINE_LOG = 'IksorisParkingTicketCashlessMachineLog',
  SELF_POS_ACCESS_TICKET_CASHLESS_MACHINE_LOG = 'SelfPOSAccessTicketCashlessMachineLog',
}
